const DISCOUNT_CODE = Object.freeze({
  FAMILY_PLAN: 'E846h1QP'
})

export default DISCOUNT_CODE



// WEBPACK FOOTER //
// ./src/constants/registration/discountCode.js